import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useProjectList } from '@/api/models/main'
import { maskPhoneNumber } from '@/utils/maskPhoneNumber'

import { UsersService } from '..'

export const CONTACT_DETAILS_QUERY_KEY = 'contact-details'

type Props = {
  contactId: string
}

export const useUserContactDetails = ({ contactId }: Props) => {
  const { data: projectList = [] } = useProjectList()

  const { data: contact, ...rest } = useQuery({
    queryKey: [CONTACT_DETAILS_QUERY_KEY, contactId],
    queryFn: () => UsersService.getContactById(contactId),
    enabled: Boolean(contactId)
  })

  const contactDetails = useMemo(() => {
    const projectsMap = new Map()
    const premisesMap = new Map()

    projectList.forEach(({ bc_guid, bc_name, premises }) => {
      projectsMap.set(bc_guid, bc_name)

      premises.forEach(({ id, name }) => {
        premisesMap.set(id, name)
      })
    })

    return {
      ...contact,
      phone: maskPhoneNumber(contact?.phone),
      email: contact?.email,
      permissions: contact?.permissions.map(({ projectId, premises }) => ({
        projectId,
        projectName: projectsMap.get(projectId),
        premises: premises.map(({ premiseId, ...rest }) => ({
          ...rest,
          premiseId,
          premiseName: premisesMap.get(premiseId)
        }))
      }))
    }
  }, [contact, projectList])

  return {
    contact: contactDetails,
    ...rest
  }
}
